export default {
    "auth.login.title": "Login",
    "auth.login.seo_description": "Log in to your CitoyenPro account to resume your preparation for the Canadian citizenship exam.",
    "auth.login.welcome": "Welcome back!",
    "auth.login.subtitle": "Log in to continue your learning",
    "auth.login.email": "Email address",
    "auth.login.email_placeholder": "your@email.com",
    "auth.login.password": "Password",
    "auth.login.password_placeholder": "••••••••",
    "auth.login.remember_me": "Remember me",
    "auth.login.forgot_password": "Forgot password?",
    "auth.login.submit": "Login",
    "auth.login.logging_in": "Logging in...",
    "auth.login.no_account": "Don't have an account?",
    "auth.login.create_account": "Create an account",
    "auth.login.back_home": "Back to home",
    "auth.login.reset_success": "Your password has been successfully changed. Please log in with your new credentials.",

    "auth.signup.title": "Create an account",
    "auth.signup.seo_description": "Sign up for CitoyenPro and start preparing for your citizenship exam with the best tools.",
    "auth.signup.welcome": "Get started today",
    "auth.signup.subtitle": "Create your CitoyenPro account in seconds",
    "auth.signup.full_name": "Full name",
    "auth.signup.full_name_placeholder": "John Doe",
    "auth.signup.submit": "Create my account",
    "auth.signup.signing_up": "Creating account...",
    "auth.signup.have_account": "Already have an account?",
    "auth.signup.login": "Login",
    "auth.signup.success": "Account created successfully! Please check your email to confirm your registration.",
    "auth.signup.terms_prefix": "I accept the",
    "auth.signup.terms_link": "terms of use",
    "auth.signup.terms_and": "and the",
    "auth.signup.privacy_link": "privacy policy",

    "auth.forgot.title": "Forgot password",
    "auth.forgot.subtitle": "Enter your email to receive a reset link",
    "auth.forgot.submit": "Send link",
    "auth.forgot.sending": "Sending...",
    "auth.forgot.back_login": "Back to login",
    "auth.forgot.success": "If an account exists for this email, you will receive a reset link shortly.",

    "auth.reset.title": "Reset password",
    "auth.reset.welcome": "New password",
    "auth.reset.subtitle": "Choose a new secure password",
    "auth.reset.new_password": "New password",
    "auth.reset.confirm_password": "Confirm password",
    "auth.reset.submit": "Update",
    "auth.reset.updating": "Updating...",
    "auth.reset.error_match": "Passwords do not match.",
    "auth.reset.error_length": "Password must be at least 6 characters long."
};
